export const ASSET_KIND = {
  IMAGE: 'image',
};
